import styled from "styled-components";

const HeaderALF = styled.header`
    text-align: left;
    font-size: 20px;
    font-weight: 700;
    color: #ffffff;
    
    `;
export default HeaderALF;